<template>
    <group-report-template v-model:current-report-template-id="currentReportTemplateId"
                           v-model:display-section="displaySection"
                           v-model:for-group="forGroup"
                           v-model:interval="$data._interval"
                           v-model:ran-report="$data._reportSuccessfullySent"
                           v-model:reload-data="$data._reloadTable"
                           v-model:running-errors="$data._errorSending"
                           v-model:running-report="$data._runningReport"
                           v-model:settings="$data._settings"
                           :can-edit="permissions.can('manage_device_summary_report')"
                           :default-settings="defaultSettings"
                           report-name="weekly-device-summary-report"
                           @useStandardReporting="setUseStandardReporting"
    >
        <template #create-settings>
            <weekly-device-summary-report-settings
                v-model:interval="$data._interval"
                v-model:settings="$data._settings"
                :is-savable="true"
            ></weekly-device-summary-report-settings>
        </template>

        <template #edit-settings>
            <weekly-device-summary-report-settings
                v-model:interval="$data._interval"
                v-model:settings="$data._settings"
                :is-savable="displaySection === 'show-template' || useStandardReporting"
            ></weekly-device-summary-report-settings>
        </template>

        <template #run-options="props">
            <div    v-if="displaySection === 'show-template'"
                    class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                <label for="offlineDevices">Show Offline Devices in Report</label>
                <toggle
                    id="offlineDevices"
                    v-model:value="$data._settings['show_offline']"
                    name="offlineDevices">
                </toggle>
            </div>

            <meter-interval-selection v-model:end-of-interval="endOfInterval"
                                      v-model:interval="$data._interval"
                                      v-model:selected-meters="$data._selectedMeters"
                                      :max-date="maxDate"
                                      :meters="metersByGroup[props.groupId]"
                                      :min-date="minDate"
                                      :timezone="timezone"
                                      @run-report="runReport(currentReportTemplateId)"
            ></meter-interval-selection>

        </template>
    </group-report-template>
</template>

<script>
import axios from "axios"
import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue'
import {SonicuCoreMixin} from "../../mixins/SonicuCoreMixin";
import {ajaxTableMixin} from "../../mixins/ajaxTableMixin";
import ReportHomeModal from "./ReportHomeModal";
import ButtonBlueSecondary from "../elements/buttons/ButtonBlueSecondary";
import BaseReport from "../Reports/BaseReport";
import MeterIntervalSelection from "./MeterIntervalSelection";
import DetailedAlarmReportSettings from "./DetailedAlarmReportSettings";
import AjaxTable from "../elements/AjaxTable";
import Select2 from "../elements/select2";
import SlideOverPanel from "../elements/SlideOverPanel";
import ButtonRedSecondary from "../elements/buttons/ButtonRedSecondary";
import ButtonGreenPrimary from "../elements/buttons/ButtonGreenPrimary";
import GroupReportTemplate from "./GroupReportTemplate";
import RoomConditionReportSettings from "@/components/GroupReports/RoomConditionReportSettings";
import WeeklyDeviceSummaryReportSettings from "@/components/GroupReports/WeeklyDeviceSummaryReportSettings";
import Toggle from "../elements/toggle.vue";

export default {
    name: "GroupWeeklyDeviceSummaryReport",
    mixins: [SonicuCoreMixin, ajaxTableMixin],
    components: {
        Toggle,
        WeeklyDeviceSummaryReportSettings,
        RoomConditionReportSettings,
        GroupReportTemplate,
        ButtonGreenPrimary,
        ButtonRedSecondary,
        SlideOverPanel,
        AjaxTable,
        DetailedAlarmReportSettings, MeterIntervalSelection, BaseReport, ReportHomeModal, ButtonBlueSecondary, Select2,
        Menu, MenuButton, MenuItem, MenuItems,
    },
    props: {
        receiveWeekday: {
            type: Number,
            default: 1,
        },
        autoSendHours: {
            type: Array
        },
        meters: {
            type: Object,
            default() {
                return {}
            },
        },
        metersByGroup: {
            type: Object,
            default() {
                return {}
            },
        },
        interval: {
            type: String,
            default: 'weekly',
        },
        minDate: {
            type: Date
        },
        maxDate: {
            type: Date
        },
        defaultSettings: {
            type: Object,
            default() {
                return {}
            }
        },
        timezone: {
            type: String,
            default: 'America/New_York'
        },
    },
    data() {
        return {
            displaySection: null,

            endOfInterval: new Date(),
            _selectedMeters: [],
            _templateName: '',
            _groupId: null,
            _interval: this.interval,

            _data: [],
            _settings: this.defaultSettings,

            _reloadTable: false,
            _runningReport: false,
            _reportSuccessfullySent: false,
            _errorSending: [],

            currentReportTemplateId: null,
            forGroup: false,
            useStandardReporting: false,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        runReport(reportTemplateId = null) {
            console.log(`Running report on DAR file w/ reportTemplateIndex: ${reportTemplateId}`)
            let params = {}
            if (reportTemplateId !== null) {
                params['reportTemplateId'] = reportTemplateId
                params['forGroup'] = this.forGroup
            } else {
                params['interval'] = this.$data._interval
            }

            params['end'] = this.$data.endOfInterval
            params['meters'] = this.$data._selectedMeters
            params['sendTime'] = this.send
            params['view_type'] = 'View PDF'
            params['show_offline'] = this.$data._settings['show_offline']

            // return
            this.$data._runningReport = true
            axios.post(this.company.buildCompanyRoute('group-reports/weekly-device-summary'), params)
                .then(response => {
                    let data = response.data
                    console.log(`Report Queued successfully, data is`)
                    console.log(data)
                    // Clear the error logs, since the report is done.
                    this.$data._reportSuccessfullySent = true
                    this.$data._errorSending = []
                })
                .catch(response => {
                    let data = response.data
                    console.log(`Report Queued Failed, data is`)
                    console.log(data)
                    // Store the logs from errors to show.
                    this.$data._errorSending = data
                })
                .finally(() => {
                    console.log(`Report finalizing`)
                    // Finish the sending of the report.
                    this.$data._runningReport = false
                })
        },
        resetTemplateRun() {
            this.currentReportTemplateIndex = null
            this.forGroup = false
        },
        setUseStandardReporting(event) {
            this.useStandardReporting = event
        }
    },
    computed: {},
    watch: {
        receiveWeekday(val, old) {
            if (val !== old) {
                this.$data._settings.receiveWeekday = val
            }
        },
    },
}
</script>

<style scoped>

</style>